<template>
  <div class="swiper-base __flex __flex-vc __flex-cc">
    <swiper class="my-swiper-base" ref="videoSwiper" v-if="list.length" :options="swiperOption">
      <swiper-slide v-for="(item, index) in list" :key="index" :class="stopSwiping?'stop-swiping':''" :data-id="item.id">
        <video v-if="item.bgVideo" class="video_back" :src="formatAliyunPath(item.bgVideo)" :poster="formatAliyunPath(item.bgVideo)+'?x-oss-process=video/snapshot,t_5000,f_jpg'" type="video/mp4" muted controls loop="loop"
          style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
          视频正在加载中...
        </video>
        <img v-else-if="item.imgSrc" width="100%" class="banner-img" :src="formatAliyunPath(item.imgSrc)+'?x-oss-process=image/resize,p_50'" @click="toDetailsPage(item)"/>
        <video v-else class="video_back" src="../../assets/video/default.mp4" type="video/mp4" muted controls loop="loop"
          style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
          视频正在加载中...
        </video>
      </swiper-slide>
    </swiper>
    <div class="content-pagination __flex __flex-vc __flex-cb" v-if="showBottomMask">
      <div class="shade-box"></div>
      <p v-if="list.length" class="pagination_name __fs-12 __line1 __cor-f __ta-left">{{list[currentIndex].name}}</p>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'BaseSwiper',
  props: {
    list: { // 轮播列表
      type: Array,
    },
    autoplay: { // 是否自动轮播
      type: Boolean,
      default: true
    },
    showBottomMask: { // 是否显示下面的点击轮播的左右箭头
      type: Boolean,
      default: true
    },
    swiperIndex: { // 当前轮播第几张
      type: Number,
      default: 0
    },
    stopSwiping: { // 是否可以手动操作轮播，左右滑动
      type: Boolean,
      default: false
    },
    swiperLoop: { // 是否循环轮播
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      currentIndex: 0, // 当前swiper的列
      swiperOption: null, // swiper配置
    }
  },
  created () {
    this.init()
  },
  computed: {
    swiperInstancs () {
      return this.$refs.videoSwiper.swiper
    },
  },
  watch: {
    swiperIndex () {
      this.handleToSlideIndex(this.swiperIndex)
    },
    autoplay () {
      this.init()
    }
  },
  methods: {
    init () {
      let that = this
      this.swiperOption = {
        slideActiveClass: 'my-swiper-base', // 类名
        slidesPerView: 1, // 设置slider容器能够同时显示的slides数量
        loop: this.swiperLoop, // 循环播放
        autoplay: this.autoplay, // 自动播放
        speed: 1000, // 切换速度
        noSwiping: this.stopSwiping,
        noSwipingClass: 'stop-swiping',
        pagination: {
          el: '.swiper-pagination'
        },
        on: {
          // slice点击事件
          tap: function () {
            let id = that.$refs['videoSwiper'].swiper.slides[this.activeIndex].attributes['data-id'].value
            that.handleClickSlide(id)
          },
          slideChange: function () {
            let id = that.$refs['videoSwiper'].swiper.slides[this.activeIndex].attributes['data-id'].value
            that.handleSildeChange(id)
          },
        }
      }
    },
    toDetailsPage (item) {
      this.$emit('handle-click-details', item)
    },
    // 点击swiper
    handleClickSlide (currentIndex) {
      this.$emit('handle-click-slide', currentIndex)
    },
    handleSildeChange (id) {
      this.$emit('handle-change-slide', id)
    },
    // 监听到 slide 更新
    handleAutoChangePage () {
      this.currentIndex = this.swiperInstancs.realIndex
      this.$emit('handle-change-slide', this.currentIndex)
    },
    // slide 跳转到第几页
    handleToSlideIndex (index = 1) {
      this.$nextTick(() => {
        this.swiperInstancs.slideTo(index)
      })
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  },
}
</script>

<style scoped lang="scss">
.swiper-base {
  position: relative;
  width: 100%;
  height: 189px;
  .my-swiper-base {
    width: 100% !important;
    height: 100%;
  }
  .banner-img {
    height: 100%;
    border-radius: 2px;
  }
}
.content-pagination {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 30px;
  padding: 0 15px;
  box-sizing: border-box;
  z-index: 3;
  .shade-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: -1;
    opacity: 0.5;
    border-radius: 0px 0px 2px 2px;
  }
  .pagination_name {
    width: 210px;
    font-size: 12px;
  }
  /deep/.swiper-pagination {
    position: static;
    text-align: right;
    width: 96px;
    .swiper-pagination-bullet {
      background-color: #fff;
      margin-left: 7px;
      opacity: .8;
    }
    .swiper-pagination-bullet-active {
      background-color: $main-color
    }
  }
}
</style>
